/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DoorLocation {
  Front = 'FRONT',
  Back = 'BACK',
  Left = 'LEFT',
  Right = 'RIGHT'
}
